import { useEffect, useState } from 'react'
import api from '../../../Services/Api'
import { useNotify } from 'react-admin'

export const BenchmarkList = (props) => {
  const [insurerOptions, setInsurerOptions] = useState([])
  const [destinationOptions, setDestinationOptions] = useState([])

  const [insurerId, setInsurerId] = useState('')
  const [destinyId, setDestinyId] = useState('')

  const [checkIn, setCheckIn] = useState()
  const [checkOut, setCheckOut] = useState()

  const [msCoupon, setMsCoupon] = useState()

  const [record, setRecord] = useState()

  const [loading, setLoading] = useState(false);

  const notify = useNotify()

  useEffect(() => {
    ; (async () => {
      try {
        const result = await api.get(
          `admin/destinations?_order=ASC&_sort=name`
        )

        setDestinationOptions(result.data)
      } catch (error) {
        console.log('Erro ao consultar coberturas', error)
      }
    })()
  }, [])

  useEffect(() => {
    ; (async () => {
      try {
        const result = await api.get(`admin/insurers?_order=ASC&_sort=name`)
        let insurers = result?.data;
        setInsurerOptions(insurers)
      } catch (error) {
        console.log('Erro ao consultar insurers', error)
      }
    })()
  }, [])

  const handleSearch = async () => {
    setLoading(true);
    try {
      const { data } = await api.get(`/admin/benchmark`, {
        params: {
          checkIn,
          checkOut,
          insurerId,
          destinyId,
          msCoupon
        }
      })

      console.log("o data aqui oh:", data);

      setRecord(data.data)
    } catch (error) {
      notify('Falha ao consultar produtos', 'error')
      console.log('Erro ao consultar produtos', error)
    } finally {
      setLoading(false);
    }
  }

  return (
    <>
      <div
        style={{
          display: 'flex',
          flexWrap: 'wrap',
          gap: '16px',
          alignItems: 'flex-start',
          padding: '10px',
          maxWidth: '100%',
          boxSizing: 'border-box',
          marginBottom: '2rem',
        }}
      >
        <label
          style={{
            flex: '1 1 180px',
            minWidth: '140px',   // reduzido de 180px para 140px
            maxWidth: '300px',
            display: 'flex',
            flexDirection: 'column',
            boxSizing: 'border-box',
          }}
        >
          Destino:
          <select
            value={destinyId}
            onChange={e => setDestinyId(e.target.value)}
            style={{
              width: '100%',
              padding: '8px',
              marginTop: '6px',
              maxWidth: '300px',
              boxSizing: 'border-box',
            }}
          >
            <option value="">Selecione</option>
            {destinationOptions.map(d => (
              <option key={d.id} value={d.id}>
                {d.name}
              </option>
            ))}
          </select>
        </label>

        <label
          style={{
            flex: '1 1 140px',
            minWidth: '120px',  // reduzido de 140px para 120px
            maxWidth: '200px',
            display: 'flex',
            flexDirection: 'column',
            boxSizing: 'border-box',
          }}
        >
          Data Início:
          <input
            type="date"
            value={checkIn}
            onChange={e => setCheckIn(e.target.value)}
            style={{
              width: '100%',
              padding: '8px',
              marginTop: '6px',
              maxWidth: '200px',
              boxSizing: 'border-box',
            }}
          />
        </label>

        <label
          style={{
            flex: '1 1 140px',
            minWidth: '120px',  // reduzido de 140px para 120px
            maxWidth: '200px',
            display: 'flex',
            flexDirection: 'column',
            boxSizing: 'border-box',
          }}
        >
          Data Fim:
          <input
            type="date"
            value={checkOut}
            onChange={e => setCheckOut(e.target.value)}
            style={{
              width: '100%',
              padding: '8px',
              marginTop: '6px',
              maxWidth: '200px',
              boxSizing: 'border-box',
            }}
          />
        </label>

        <label
          style={{
            flex: '1 1 140px',
            minWidth: '120px',  // reduzido de 140px para 120px
            maxWidth: '200px',
            display: 'flex',
            flexDirection: 'column',
            boxSizing: 'border-box',
          }}
        >
          Cupom MS:
          <input
            type="text"
            value={msCoupon}
            onChange={e => setMsCoupon(e.target.value)}
            style={{
              width: '100%',
              padding: '8px',
              marginTop: '6px',
              maxWidth: '200px',
              boxSizing: 'border-box',
            }}
          />
        </label>

        <label
          style={{
            flex: '1 1 180px',
            minWidth: '140px',   // reduzido de 180px para 140px
            maxWidth: '300px',
            display: 'flex',
            flexDirection: 'column',
            boxSizing: 'border-box',
          }}
        >
          Seguradora:
          <select
            value={insurerId}
            onChange={e => setInsurerId(e.target.value)}
            style={{
              width: '100%',
              padding: '8px',
              marginTop: '6px',
              maxWidth: '300px',
              boxSizing: 'border-box',
            }}
          >
            <option value="">Todas</option>
            {insurerOptions.map(i => (
              <option key={i.id} value={i.id}>
                {i.name}
              </option>
            ))}
          </select>
        </label>

        <button
          onClick={handleSearch}
          disabled={loading}
          style={{
            padding: '12px 20px',
            backgroundColor: '#007bff',
            border: 'none',
            borderRadius: '4px',
            color: 'white',
            cursor: 'pointer',
            flex: '0 1 auto',
            maxWidth: '200px',
            marginTop: '6px',
            alignSelf: 'flex-end',  // ALINHA O BOTÃO NA BASE DOS INPUTS
            boxSizing: 'border-box',
          }}
        >
          {loading ? 'Buscando...' : 'Buscar'}
        </button>
      </div>

      {loading ? (
        <div style={{
          marginTop: '16px',
          color: '#666',
          textAlign: 'center',
          fontSize: '16px',
          padding: '12px',
        }}>
          🔄 Carregando dados, por favor aguarde...
        </div>
      ) : <div style={{ width: '100%', padding: '1rem' }}>
        {/* Tabela de produtos com match */}
        {record && record.matchProducts?.length > 0 && (
          <div style={{ overflowX: 'auto' }}>
            <table
              style={{
                width: '100%',
                borderCollapse: 'collapse',
                fontFamily: 'Arial, sans-serif',
                marginBottom: '40px',
                boxShadow: '0 2px 6px rgba(0,0,0,0.08)',
              }}
            >
              <thead>
                <tr>
                  <th colSpan={3} style={{ backgroundColor: '#1f037b', color: 'white', padding: '12px' }}>
                    Melhor Seguro
                  </th>
                  <th colSpan={3} style={{ backgroundColor: '#004929', color: 'white', padding: '12px' }}>
                    Seguros Promo
                  </th>
                  <th
                    style={{
                      backgroundColor: '#e0e0e0',
                      fontWeight: '600',
                      padding: '12px',
                      whiteSpace: 'nowrap',
                    }}
                  >
                    Diferença de Preço (R$)
                  </th>
                  <th
                    style={{
                      backgroundColor: '#e0e0e0',
                      fontWeight: '600',
                      padding: '12px',
                      whiteSpace: 'nowrap',
                    }}
                  >
                    Diferença de Preço (%)
                  </th>
                </tr>
                <tr style={{ backgroundColor: '#f5f5f5' }}>
                  <th style={{ padding: '10px' }}>Nome</th>
                  <th style={{ padding: '10px' }}>DMH</th>
                  <th style={{ padding: '10px' }}>Preço</th>
                  <th style={{ padding: '10px' }}>Nome</th>
                  <th style={{ padding: '10px' }}>DMH</th>
                  <th style={{ padding: '10px' }}>Preço</th>
                  <th></th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {record.matchProducts.map((item) => {
                  const msPrice = item.msProduct.price;
                  const spPrice = item.spProduct.price;
                  const isCheaper = msPrice < spPrice;

                  return (
                    <tr key={item.msProduct.id} style={{ backgroundColor: '#fff' }}>
                      <td style={{ padding: '10px' }}>{item.msProduct.name}</td>
                      <td style={{ padding: '10px', textAlign: 'center' }}>{item.msProduct.dmh}</td>
                      <td
                        style={{
                          padding: '10px',
                          color: isCheaper ? 'green' : '#f00',
                          fontWeight: 'bold',
                          textAlign: 'right',
                        }}
                      >
                        R$ {msPrice.toFixed(2)}
                      </td>
                      <td style={{ padding: '10px' }}>{item.spProduct.name}</td>
                      <td style={{ padding: '10px', textAlign: 'center' }}>{item.spProduct.dmh}</td>
                      <td style={{ padding: '10px', textAlign: 'right' }}>
                        R$ {spPrice.toFixed(2)}
                      </td>
                      <td style={{ padding: '10px', textAlign: 'right' }}>
                        R$ {item.priceDifference.toFixed(2)}
                      </td>
                      <td style={{ padding: '10px', textAlign: 'right' }}>
                        {item.priceDifferencePercent.toFixed(2)}%
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        )}

        {/* Tabelas de produtos sem correspondência */}
        {record && record.noMatchProducts && (
          <div
            style={{
              display: 'flex',
              flexWrap: 'wrap',
              width: '100%',
              gap: '24px',
              marginTop: '2rem',
            }}
          >
            {/* MS Produtos sem correspondência */}
            <div style={{ flex: '1 1 400px', minWidth: '300px' }}>
              <h3
                style={{
                  backgroundColor: '#1f037b',
                  color: 'white',
                  padding: '12px',
                  borderTopLeftRadius: '6px',
                  borderTopRightRadius: '6px',
                  margin: 0,
                }}
              >
                Produtos Melhor Seguro sem correspondência
              </h3>
              <table
                style={{
                  width: '100%',
                  borderCollapse: 'collapse',
                  fontFamily: 'Arial, sans-serif',
                  boxShadow: '0 2px 6px rgba(0,0,0,0.05)',
                }}
              >
                <thead>
                  <tr style={{ backgroundColor: '#f5f5f5' }}>
                    <th style={{ padding: '10px' }}>ID</th>
                    <th style={{ padding: '10px' }}>Nome</th>
                    <th style={{ padding: '10px' }}>DMH</th>
                    <th style={{ padding: '10px' }}>Preço</th>
                  </tr>
                </thead>
                <tbody>
                  {record.noMatchProducts.msProducts.map((item) => (
                    <tr key={item.id} style={{ backgroundColor: '#fff' }}>
                      <td style={{ padding: '10px' }}>{item.id}</td>
                      <td style={{ padding: '10px' }}>{item.name}</td>
                      <td style={{ padding: '10px', textAlign: 'center' }}>{item.dmh}</td>
                      <td style={{ padding: '10px', textAlign: 'right' }}>
                        R$ {item.price.toFixed(2)}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            {/* SP Produtos sem correspondência */}
            <div style={{ flex: '1 1 400px', minWidth: '300px' }}>
              <h3
                style={{
                  backgroundColor: '#004929',
                  color: 'white',
                  padding: '12px',
                  borderTopLeftRadius: '6px',
                  borderTopRightRadius: '6px',
                  margin: 0,
                }}
              >
                Produtos Seguros Promo sem correspondência
              </h3>
              <table
                style={{
                  width: '100%',
                  borderCollapse: 'collapse',
                  fontFamily: 'Arial, sans-serif',
                  boxShadow: '0 2px 6px rgba(0,0,0,0.05)',
                }}
              >
                <thead>
                  <tr style={{ backgroundColor: '#f5f5f5' }}>
                    <th style={{ padding: '10px' }}>Nome</th>
                    <th style={{ padding: '10px' }}>DMH</th>
                    <th style={{ padding: '10px' }}>Preço</th>
                  </tr>
                </thead>
                <tbody>
                  {record.noMatchProducts.spProducts.map((item, index) => (
                    <tr key={index} style={{ backgroundColor: '#fff' }}>
                      <td style={{ padding: '10px' }}>{item.name}</td>
                      <td style={{ padding: '10px', textAlign: 'center' }}>{item.dmh}</td>
                      <td style={{ padding: '10px', textAlign: 'right' }}>
                        {item.currency} {item.price.toFixed(2)}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        )}
      </div>}
    </>
  )
}